module.exports = __webpack_public_path__ + "static/media/iPhoneXWhiteModal.1cfcc88a.png";